
import * as style from './style.css';
import React = require('react');

interface IProps {

    errors?: string[];
}

interface IState {

}

export default class ErrorsComp extends React.Component<IProps, IState> {
    render() {
        return this.errors(this.props.errors);
    }

    errors(errors: string[]): React.ReactElement {
        if (errors === null || errors === undefined || errors.length === 0) { return <></>; }

        return (<div className={style.errors}>
            {errors.map((e, i) =>
                <span key={i} className={style.error}>{e}</span>
            )}
        </div>);
    }
}
